// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CoverMyMedsV1ClientGeneratedAddressModel } from './coverMyMedsV1ClientGeneratedAddressModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsV1ClientGeneratedProviderModel {
    'firstName'?: string | null;
    'lastName'?: string | null;
    'npi'?: string | null;
    'officeContact'?: string | null;
    'officeContactFax'?: string | null;
    'officeContactPhone'?: string | null;
    'officeContactTimePreferences'?: Array<string> | null;
    'officeFax'?: string | null;
    'officePhone'?: string | null;
    'primaryAddress'?: CoverMyMedsV1ClientGeneratedAddressModel | null;
    'siteInstitutionName'?: string | null;
    'stateLicenseNumber'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsV1ClientGeneratedProviderModel>> = [
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "npi",
            "baseName": "npi",
            "type":     "string"
        },
        {
            "name":     "officeContact",
            "baseName": "officeContact",
            "type":     "string"
        },
        {
            "name":     "officeContactFax",
            "baseName": "officeContactFax",
            "type":     "string"
        },
        {
            "name":     "officeContactPhone",
            "baseName": "officeContactPhone",
            "type":     "string"
        },
        {
            "name":     "officeContactTimePreferences",
            "baseName": "officeContactTimePreferences",
            "type":     "Array<string>"
        },
        {
            "name":     "officeFax",
            "baseName": "officeFax",
            "type":     "string"
        },
        {
            "name":     "officePhone",
            "baseName": "officePhone",
            "type":     "string"
        },
        {
            "name":     "primaryAddress",
            "baseName": "primaryAddress",
            "type":     "CoverMyMedsV1ClientGeneratedAddressModel"
        },
        {
            "name":     "siteInstitutionName",
            "baseName": "siteInstitutionName",
            "type":     "string"
        },
        {
            "name":     "stateLicenseNumber",
            "baseName": "stateLicenseNumber",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsV1ClientGeneratedProviderModel.attributeTypeMap;
    }
}
